import { Tier } from '../api/slots';

// Оригинальные плоские SVG-символы (рисованы под проект, без сторонних ассетов).
// Цвет фона — по тиру (единый для всех тем, чтобы выигрыши читались), глиф — по теме.

const TIER_BG: Record<Tier, string> = {
  wild: '#ffcf33',
  scatter: '#18d6ff',
  h1: '#ff5b6e',
  h2: '#b06bff',
  m1: '#4d9bff',
  m2: '#1fd1a8',
  l1: '#5bd16b',
  l2: '#ff9e3d',
};

// глиф рисуем поверх плитки. Возвращаем SVG-children для viewBox 0 0 64 64.
type G = JSX.Element;
const D = '#0c1118';

function fruits(t: Tier): G {
  switch (t) {
    case 'l2': // вишня
      return (<g fill="#7a1020"><circle cx="24" cy="42" r="11" /><circle cx="42" cy="44" r="11" /><path d="M24 31C28 18 40 16 46 14" stroke="#2f7d32" strokeWidth="3" fill="none" /></g>);
    case 'l1': // лимон
      return (<ellipse cx="32" cy="34" rx="18" ry="13" fill="#caa400" transform="rotate(-20 32 34)" />);
    case 'm2': // апельсин
      return (<g><circle cx="32" cy="36" r="15" fill="#c25e00" /><path d="M30 18l8 2-4 6z" fill="#2f7d32" /></g>);
    case 'm1': // слива
      return (<g><circle cx="32" cy="36" r="15" fill="#5a2a7a" /><path d="M32 22V14" stroke="#2f7d32" strokeWidth="3" /></g>);
    case 'h2': // виноград
      return (<g fill="#3a1d63"><circle cx="26" cy="30" r="7" /><circle cx="38" cy="30" r="7" /><circle cx="32" cy="40" r="7" /><circle cx="44" cy="40" r="7" /><circle cx="20" cy="40" r="7" /><circle cx="32" cy="50" r="7" /></g>);
    case 'h1': // арбуз
      return (<g><path d="M14 40a18 18 0 0136 0z" fill="#1f7a2e" /><path d="M18 40a14 14 0 0128 0z" fill="#e23b4e" /><circle cx="26" cy="34" r="1.6" fill={D} /><circle cx="38" cy="34" r="1.6" fill={D} /><circle cx="32" cy="37" r="1.6" fill={D} /></g>);
    case 'scatter': // семёрка
      return (<path d="M20 18h26l-14 30h-9l13-23H20z" fill="#d11" />);
    case 'wild': // звезда
      return (<path d="M32 12l6 14 15 1-11 10 3 15-13-8-13 8 3-15-11-10 15-1z" fill="#a06b00" />);
  }
}

function egypt(t: Tier): G {
  switch (t) {
    case 'l2': // жук
      return (<g fill="#2b2b3a"><ellipse cx="32" cy="36" rx="12" ry="16" /><path d="M20 30l-8-4M44 30l8-4M20 42l-8 4M44 42l8 4" stroke="#2b2b3a" strokeWidth="3" /></g>);
    case 'l1': // пирамида
      return (<path d="M32 16L52 48H12z" fill="#caa14a" />);
    case 'm2': // анкх
      return (<g stroke="#1c6e8c" strokeWidth="6" fill="none"><circle cx="32" cy="24" r="8" /><path d="M32 32v22M22 40h20" /></g>);
    case 'm1': // анубис
      return (<g fill="#26323d"><path d="M22 20l-4-8 8 4zM42 20l4-8-8 4z" /><path d="M22 18h20v18a10 10 0 01-20 0z" /></g>);
    case 'h2': // скарабей
      return (<g fill="#2e9e7a"><circle cx="32" cy="36" r="11" /><path d="M14 30q18 -14 36 0M14 44q18 12 36 0" stroke="#2e9e7a" strokeWidth="3" fill="none" /></g>);
    case 'h1': // око Гора
      return (<g fill="none" stroke="#1c6e8c" strokeWidth="4"><path d="M14 34q18 -16 36 0q-18 16 -36 0" /><circle cx="32" cy="34" r="5" fill="#1c6e8c" /><path d="M30 44l-4 10" /></g>);
    case 'scatter': // книга
      return (<g><rect x="16" y="16" width="32" height="32" rx="3" fill="#7a4a1a" /><path d="M32 18v28" stroke="#caa14a" strokeWidth="3" /></g>);
    case 'wild': // маска фараона
      return (<g><path d="M20 16h24v8l-4 26h-16l-4-26z" fill="#1c6e8c" /><path d="M26 28h12M28 36h8" stroke="#caa14a" strokeWidth="3" /></g>);
  }
}

function space(t: Tier): G {
  switch (t) {
    case 'l2': // кристалл
      return (<path d="M32 14l14 12-14 24-14-24z" fill="#6fd0ff" />);
    case 'l1': // астероид
      return (<g fill="#6b7384"><circle cx="32" cy="36" r="15" /><circle cx="26" cy="32" r="3" fill="#4a5160" /><circle cx="38" cy="40" r="4" fill="#4a5160" /></g>);
    case 'm2': // комета
      return (<g><circle cx="40" cy="26" r="9" fill="#7fb3ff" /><path d="M34 32L14 52" stroke="#7fb3ff" strokeWidth="6" strokeLinecap="round" /></g>);
    case 'm1': // спутник
      return (<g fill="#9fb0c4"><rect x="28" y="28" width="12" height="12" rx="2" /><rect x="10" y="30" width="14" height="8" /><rect x="44" y="30" width="14" height="8" /></g>);
    case 'h2': // ракета
      return (<g><path d="M32 12c8 6 10 18 6 30H26c-4-12-2-24 6-30z" fill="#e8edf5" /><circle cx="32" cy="28" r="4" fill="#18d6ff" /><path d="M26 42l-6 8h8zM38 42l6 8h-8z" fill="#ff5b6e" /></g>);
    case 'h1': // планета с кольцом
      return (<g><circle cx="32" cy="34" r="13" fill="#b06bff" /><ellipse cx="32" cy="34" rx="22" ry="7" fill="none" stroke="#ffcf33" strokeWidth="3" /></g>);
    case 'scatter': // звезда
      return (<path d="M32 12l6 14 15 1-11 10 3 15-13-8-13 8 3-15-11-10 15-1z" fill="#0c5a73" />);
    case 'wild': // НЛО
      return (<g><ellipse cx="32" cy="40" rx="20" ry="7" fill="#9fb0c4" /><path d="M22 34a10 8 0 0120 0z" fill="#18d6ff" /></g>);
  }
}

function west(t: Tier): G {
  switch (t) {
    case 'l2': // туз
      return (<g><rect x="20" y="14" width="24" height="36" rx="3" fill="#f3f3f3" /><path d="M32 22l6 18h-12z M28 34h8" stroke="#b00" strokeWidth="2.5" fill="none" /></g>);
    case 'l1': // бочонок
      return (<g fill="#7a4a1a"><rect x="20" y="18" width="24" height="30" rx="6" /><path d="M20 28h24M20 38h24" stroke="#caa14a" strokeWidth="2.5" /></g>);
    case 'm2': // подкова
      return (<path d="M22 50V34a10 10 0 0120 0v16" fill="none" stroke="#caa14a" strokeWidth="7" strokeLinecap="round" />);
    case 'm1': // череп
      return (<g fill="#e8e8ea"><circle cx="32" cy="30" r="14" /><rect x="26" y="40" width="12" height="8" /><circle cx="26" cy="30" r="3" fill={D} /><circle cx="38" cy="30" r="3" fill={D} /></g>);
    case 'h2': // револьвер
      return (<g fill="#6b7384"><rect x="14" y="28" width="30" height="7" /><path d="M40 35v10h-8z" /><circle cx="34" cy="31" r="6" /></g>);
    case 'h1': // шериф (звезда-бейдж)
      return (<g><path d="M32 12l6 12 13 1-10 9 3 13-12-7-12 7 3-13-10-9 13-1z" fill="#caa14a" /><circle cx="32" cy="32" r="4" fill={D} /></g>);
    case 'scatter': // динамит
      return (<g><rect x="22" y="22" width="9" height="26" rx="2" fill="#d11" /><rect x="33" y="22" width="9" height="26" rx="2" fill="#d11" /><path d="M32 22V14" stroke="#caa14a" strokeWidth="3" /></g>);
    case 'wild': // ковбойская шляпа
      return (<g fill="#5a3a1a"><path d="M22 32c0-10 20-10 20 0z" /><ellipse cx="32" cy="38" rx="22" ry="6" /></g>);
  }
}

function dogs(t: Tier): G {
  const face = (ear: string, col: string, snout: string) => (
    <g>
      <path d={ear} fill={col} />
      <circle cx="32" cy="36" r="15" fill={col} />
      <ellipse cx="32" cy="42" rx="7" ry="5" fill={snout} />
      <circle cx="26" cy="33" r="2.4" fill={D} />
      <circle cx="38" cy="33" r="2.4" fill={D} />
      <circle cx="32" cy="40" r="2" fill={D} />
    </g>
  );
  switch (t) {
    case 'l2': // мячик
      return (<g><circle cx="32" cy="36" r="15" fill="#ff5b6e" /><path d="M17 36h30M32 21v30" stroke="#fff" strokeWidth="2.5" /></g>);
    case 'l1': // будка
      return (<g><path d="M16 34L32 18l16 16z" fill="#7a4a1a" /><rect x="20" y="34" width="24" height="16" fill="#a06a30" /><circle cx="32" cy="44" r="6" fill={D} /></g>);
    case 'm2': // лапа
      return (<g fill="#caa14a"><circle cx="32" cy="40" r="9" /><circle cx="22" cy="30" r="4" /><circle cx="32" cy="26" r="4" /><circle cx="42" cy="30" r="4" /></g>);
    case 'm1': // мопс
      return face('M22 24l-4-8 8 4zM42 24l4-8-8 4z', '#d6b78a', '#3a2c1c');
    case 'h2': // шиба
      return face('M20 22l2-10 8 6zM44 22l-2-10-8 6z', '#e08a3c', '#fff');
    case 'h1': // хаски
      return face('M20 22l2-10 8 6zM44 22l-2-10-8 6z', '#9fb0c4', '#fff');
    case 'scatter': // кость
      return (<g fill="#f0ead6"><rect x="22" y="28" width="20" height="8" rx="4" /><circle cx="22" cy="26" r="5" /><circle cx="22" cy="38" r="5" /><circle cx="42" cy="26" r="5" /><circle cx="42" cy="38" r="5" /></g>);
    case 'wild': // корги
      return face('M20 22l0-12 9 7zM44 22l0-12-9 7z', '#e0a050', '#fff');
  }
}

const THEME_GLYPH: Record<string, (t: Tier) => G> = {
  fruits, egypt, space, west, dogs,
};

export function SlotSymbol({ theme, tier, size = 56 }: { theme: string; tier: Tier; size?: number }) {
  const glyphFn = THEME_GLYPH[theme] ?? fruits;
  const isSpecial = tier === 'wild' || tier === 'scatter';
  return (
    <div
      className={`slot-sym tier-${tier}`}
      style={{ width: size, height: size, background: `linear-gradient(160deg, ${TIER_BG[tier]}, ${TIER_BG[tier]}cc)` }}
    >
      <svg viewBox="0 0 64 64" width="100%" height="100%">
        {glyphFn(tier)}
      </svg>
      {isSpecial && <span className="slot-sym-tag">{tier === 'wild' ? 'WILD' : 'SCATTER'}</span>}
    </div>
  );
}
